export function ModMapping(moduleName) {
  if (moduleName === 'User') return '101'
  else if (moduleName === 'Quotation') return '102'
  else if (moduleName === 'Claim') return '103'
  else if (moduleName === 'Product') return '104'
  else if (moduleName === 'Customers') return '105'
  else if (moduleName === 'Policy') return '106'
  else if (moduleName === 'Insurer') return '107'
  else if (moduleName === 'Auth') return '108'
  else if (moduleName === 'Roleclaims') return '109'
  else if (moduleName === 'Email Template') return '110'
  else if (moduleName === 'Admin Setting') return '111'
  else if (moduleName === 'Insurer Setting') return '112'
  else if (moduleName === 'Client') return '113'
  else if (moduleName === 'Document') return '114'
  else return null // Return null if moduleName is not found
}

export function PerMapping(permissionName) {
  if (permissionName === 'Add') return '11'
  else if (permissionName === 'Update') return '12'
  else if (permissionName === 'Delete') return '13'
  else if (permissionName === 'GetSingle') return '14'
  else if (permissionName === 'GetAll') return '15'
  else if (permissionName === 'GetOwn') return '16'
  else if (permissionName === 'Transaction') return '17'
  else if (permissionName === 'Send Email') return '18'
  else if (permissionName === 'Policy Update') return '19'
  else if (permissionName === 'Approve') return '20'
  else if (permissionName === 'Pay') return '21'
  else if (permissionName === 'Upload') return '22'
  else if (permissionName === 'Assign') return '23'
  else return null // Return null if permissionName is not found
}
export function RoleIDMapping(RoleName) {
  if (RoleName === 'SuperAdmin') return '301';
  else if (RoleName === 'Underwriter') return '303';
  else if (RoleName === 'JuniorUnderwriter') return '313';
  else if (RoleName === 'ClaimManager') return '315';
  else if (RoleName === 'Broker') return '305';
  else if (RoleName === 'Insurer') return '308';
  else if (RoleName === 'Customer') return '311';
}
export default {
  ModMapping,
  PerMapping,
  RoleIDMapping
}
